<template>
    <div class="components-organize-box">
        <div class="box-title">
            <img :src="props.data.icon" alt="" />
            <div class="text">{{props.data.title }}</div> 
        </div>
        <div class="box-list">
            <div class="list-item" v-for="item in props.data.list" :key="item.title">
                <div class="item-title">{{item.title}}</div>
                <div class="item-list">
                    <div class="itema" v-for="(itema,indexa) in item.list" :key="indexa" :title="itema.title">
                        <img :src="itema.icon" alt="" />
                    </div>
                    <template v-if="item.list.length % 3 != 0">
                        <div class="itema-buchong" v-for="itema in (3-item.list.length % 3)" :key="itema"></div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
  data: {
    type: Object,
    default: () => {
      return {}
    }
  }
})
</script>

<style lang="scss" scoped>
.components-organize-box{
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 24px;
    .box-title{
        display: flex;
        align-items: center;
        img{
            width: 22px;
            height: 22px;
        }
        .text{
            color: rgb(38, 38, 38);
            font-family: 阿里巴巴普惠体 2.0;
            font-size: 20px;
            font-weight: 700;
            letter-spacing: 0px;
            margin-left: 12px;
        }
    }
    .box-list{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-top: 36px;
        .list-item{
            width: 100%;
            display: flex;
            flex-direction: column;
            margin-bottom: 24px;
            .item-title{
                color: rgb(51, 51, 51);
                font-family: Alibaba PuHuiTi 3.0;
                font-size: 16px;
                font-weight: 700;
                line-height: 20px;
                letter-spacing: 0px;
            }
            .item-list{
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                margin-top: 18px;
                .itema{
                    width: 32%;
                    aspect-ratio: 106 / 45;
                    // margin-right: 8px;
                    margin-bottom: 8px;
                    border: 1px solid rgb(218, 221, 227);
                    background: rgb(255, 255, 255);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    img{
                        max-width: 80%;
                        // max-height: 30px;
                    }
                }
                .itema-buchong{
                    width: 32%;
                    margin-bottom: 8px;
                }
            }
            @supports not(aspect-ratio: 106/45){
                .item-list{
                    .itema{
                        height: 52px;
                        img{
                            max-height: 50px;
                        }
                    }
                }
            }
        }
    }
}
</style>
